import { gql } from 'apollo-angular';

export const getHomepageModuleTokenQuery = gql`
  query {
    getActiveHomepageModuleByCustomer {
      token
    }
  }
`;
